import axiosClient from '../configs/axios';

class TransferToDepotService {

    // Get list of transfer to depot entries
    async getTransferToDepotList(params) {
        try {
            const login_details = sessionStorage.getItem('loginUser');
            const userD = JSON.parse(login_details);
            const userInfo = userD?.result?.userInfo;
            const unit_id = userInfo?.plant_id || userInfo?.depot_id;
            const response = await axiosClient.get(
                `/transfertodepot/list?page=${params.page}&size=${params.size}&searchKey=${params.searchKey || ''}&unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Get QC-passed batches available to transfer
    async getQCPassedBatches() {
        try {
            const login_details = sessionStorage.getItem('loginUser');
            const userD = JSON.parse(login_details);
            const userInfo = userD?.result?.userInfo;
            const unit_id = userInfo?.plant_id || userInfo?.depot_id;
            const response = await axiosClient.get(
                `/transfertodepot/qcPassedBatches?unit_id=${unit_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add new transfer to depot
    async addTransferToDepot(data) {
        try {
            const response = await axiosClient.post('/transfertodepot/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or soft-delete
    async editDeleteTransferToDepot(data) {
        try {
            const response = await axiosClient.put('/transfertodepot/editDelete', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new TransferToDepotService();
